export enum ControlSizeTokensEnum {
  SMALL = "sm",
  DEFAULT = "default",
  LARGE = "lg"
}
